// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__QXnRf","col":"styles_col__d7X1B"};